// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-lesotho/calculator-lesotho-affordability-home-loan/calculator-lesotho-affordability-home-loan.component.scss
// module id = 794
// module chunks = 0